import { prop } from "ramda";
import { createSelector } from "reselect";

const filtersSelector = (state: any) => state.delegationManagement;
const userSelector = (state: any) => state.app;

export const selectDelegations: any = createSelector(
  filtersSelector,
  prop("delegations")
);

export const selectDelegationsLoader: any = createSelector(
  filtersSelector,
  prop("delegationsLoader")
);

export const selectSelectedRole: any = createSelector(
  filtersSelector,
  prop("selectedRole")
);

export const selectSelectedUsersDelegation: any = createSelector(
  filtersSelector,
  prop("selectedUsers")
);

export const selectUsers: any = createSelector(filtersSelector, prop("users"));

export const selectUsersLoader: any = createSelector(
  filtersSelector,
  prop("usersLoader")
);

export const selectCallState: any = createSelector(
  filtersSelector,
  prop("callState")
);
